if (!window.helpers && !window.animation) {
  class Helpers {
    constructor() {

    }

    findElement(elementsList, findElement) {
      return Array.from(elementsList).filter(element => element === findElement)[0];
    }

    findElementsByClass(elementsList, findClass) {
      return Array.from(elementsList).filter(element => element.classList.contains(findClass));
    }

    containsOrIs(element, findElement) {
      return element === findElement || element.contains(findElement);
    }

    addEventInfo(event, str) {
      return event.eventInfo = `${event.eventInfo ? event.eventInfo + ' ' : ''}${str}`;
    }

    getSingleOrObjectKey(element, key) {
      return key !== undefined ? element[key] : element;
    }

    setSingleOrObjectKey(value, key, inheritedObject) {
      if (key !== undefined) {
        const newInnerObject = {};
        newInnerObject[key] = value;

        return Object.assign({}, inheritedObject, newInnerObject);
      } else {
        return value;
      }
    }

    processSingleOrObject(element, processFunction) {
      if (typeof element === 'object') {
        const newObject = {};

        for (const key in element) {
          newObject[key] = processFunction(element[key], key);
        }

        return newObject;
      } else {
        return processFunction(element);
      }
    }
  }

  window.helpers = new Helpers();

  class Animation {
    constructor() {
      themeBase.onDOMContentLoadedTrigger(() => {
        this.duration = 350;
        this.timing = 'easeInOutQuad';
        this.timingFunctions = timingFunctions;
        this.cashe = [];

        window.addEventListener('throttle5fpsResize', this.clearCashe.bind(this));
      });
    }

    animate(element, properties, settings = {}, callbacks = {}) {
      let start;
      const finalSettings = this.getFinalSettings(settings);
      const {
        duration,
        draw,
        timingFunction
      } = finalSettings;
      const initialValues = this.getCurrentPropertyValues(element, properties);
      const animate = time => {
        if (!start) start = time;

        const stepValues = this.getStepValues(start, time, duration, timingFunction);
        const drawValues = draw(element, properties, initialValues, stepValues.progress, settings);
        const statuses = ['step'];

        if (stepValues.timeFraction === 0) {
          element.animationStoped = false;
        }
        if (!element.animationStoped && stepValues.timeFraction < 1) {
          if (stepValues.timeFraction === 0) {
            statuses.unshift('start');
            this.setWillChange(element, properties, settings);
          }

          step();
        } else {
          statuses.push('complete');
          this.unsetWillChange(element, settings);
        }

        return Object.assign({
          element,
          statuses
        }, stepValues, drawValues);
      };
      const step = () => {
        const onStepEnd = () => {
          this.callSettingsCallbacks(elementCurrentObject.stepData, callbacks, settings);

          if (elementCurrentObject.stepData.statuses.includes('complete') || elementCurrentObject.stepData.statuses.includes('stop')) {
            if (element !== window) element.animationObject = null;
          }
        };
        const elementCurrentObject = {
          settings: finalSettings,
          methods: {
            stop: (doComplete) => {
              if (!doComplete) element.animationObject.settings.disableCompleteCallbacks = true;

              element.animationStoped = true;
              cancelAnimationFrame(elementCurrentObject.requestId);
              elementCurrentObject.stepData.statuses.push('stop');
              onStepEnd(elementCurrentObject.stepData);
            }
          }
        };

        elementCurrentObject.requestId = requestAnimationFrame(time => {
          elementCurrentObject.stepData = animate(time);
          element.animationObject = elementCurrentObject;

          onStepEnd();
        });
      };

      if (settings.initialValues) {
        initialValues = Object.assign(initialValues, settings.initialValues);
      }

      step();
    }

    draw(element, properties, initialValues, progress, settings) {
      const values = {};
      const valuesCSS = {};
      const setCSSProperty = (property, elem = element) => {
        if (property === 'scrollY' || property === 'scrollX') {
          this.setJSProperty(elem, property, valuesCSS[property]);
          return;
        }

        const valueCSS = property === 'transform' ? this.buildMatrixCSS(values[property], valuesCSS[property]) : valuesCSS[property];

        if (progress === 1 && values[property] === 0) {
          elem.style[property] = '';
          return;
        }


        this.setCSSProperty(elem, property, valueCSS);
      };

      for (const property in properties) {
        helpers.processSingleOrObject(properties[property], (propertyValue, key) => {
          propertyValue = propertyValue.toString();
          const finishValue = this.getCSSPropertyValue(propertyValue);
          const initialValue = helpers.getSingleOrObjectKey(initialValues[property], key);
          const newValue = this.getProgressValue(initialValue, finishValue, progress);
          const newValueCSS = this.rebuildNewCSSPropertyValue(propertyValue, newValue, finishValue);
          values[property] = helpers.setSingleOrObjectKey(newValue, key, values[property]);
          valuesCSS[property] = helpers.setSingleOrObjectKey(newValueCSS, key, valuesCSS[property]);
        });

        setCSSProperty(property);

        if (settings.duplicate) {
          settings.duplicate.forEach(element => setCSSProperty(property, element));
        }
      }


      return {
        values,
        valuesCSS
      };
    }

    scrollTop(offsetTop, settings = {}) {
      this.animate(
        window, {
          scrollY: offsetTop,
        },
        settings, {
          complete: () => {

          }
        }
      );
    }

    scrollTo(element = window, offsets, settings = {}) {
      this.animate(
        element, {
          scrollX: offsets.left || 0,
          scrollY: offsets.top || 0
        },
        settings, {
          complete: () => {

          }
        }
      );
    }

    slideDown(element, settings = {}) {
      const boundingElement = settings.boundingRect || element;
      const boundingRect = this.hiddenElementRectCalculation(boundingElement);

      delete element.dataset.animationSlideDownCompleted;

      element.style.height = `${getLogicalRect(element).height || 0}px`;
      element.style.overflow = 'hidden';
      element.style.display = 'block';
      this.animate(
        element, {
          height: `${boundingRect.height}px`,
        },
        settings, {
          complete: () => {
            element.style.overflow = '';
            element.dataset.animationSlideDownCompleted = true;
          }
        }
      );
    }

    slideUp(element, settings = {}) {
      if (element.dataset.animationSlideDownCompleted) {
        this.addCashe(element, getLogicalRect(element));
        delete element.dataset.animationSlideDownCompleted;
      }

      element.style.overflow = 'hidden';
      this.animate(
        element, {
          height: '0px',
        },
        settings, {
          complete: () => {
            element.style.display = '';
            element.style.overflow = '';
          }
        }
      );
    }

    slideTo(element, value, settings = {}) {
      this.animate(
        element, {
          height: `${value}px`
        },
        settings
      );
    }

    stop(element, doComplete) {
      const isAnimate = this.isAnimate(element);

      if (isAnimate) element.animationObject.methods.stop(doComplete);
      return isAnimate;
    }

    isAnimate(element) {
      return !!element.animationObject;
    }

    clearCashe() {
      this.cashe = [];
    }

    getCashe(element) {
      let cashe;
      let index;

      this.cashe.forEach((object, objectIndex) => {
        if (object.element === element) {
          cashe = object.cashe;
          index = objectIndex;
          return false;
        }
      });
      return cashe !== undefined ? {
        cashe,
        index
      } : cashe;
    }

    addCashe(element, cashe) {
      const lastCashe = this.getCashe(element);

      lastCashe ? this.cashe[lastCashe.index].cashe = cashe :
        this.cashe.push({
          element,
          cashe
        });

      return cashe;
    }

    hiddenElementRectCalculation(element) {
      const cashe = this.getCashe(element);

      if (cashe !== undefined) {
        return cashe.cashe;
      }

      const parent = element.parentNode;
      const width = window.getComputedStyle(element).width;

      parent.style.position = `${window.getComputedStyle(parent).position === 'static' ? 'relative' : ''}`;
      element.setAttribute('style', `
                visibility: hidden !important;
                position: absolute !important;
                display: block !important;
                ${width === 'auto' ? 'width: 100% !important;' : ''}`);

      const boundingRect = getLogicalRect(element);

      element.removeAttribute('style');
      parent.style.position = '';
      return this.addCashe(element, boundingRect);
    }

    getCurrentPropertyValues(element, properties) {
      const values = {};

      for (const property in properties) {
        if (element === window) {
          values[property] = window.scrollY;
        } else if (property === 'scrollY') {
          values[property] = element.scrollTop;
        } else if (property === 'scrollX') {
          values[property] = getLogicalScrollLeft(element);
        } else {
          let stringCSS = this.getCSSProperty(element, property);

          if (property === 'transform') {
            values[property] = this.getTransformObjectFromCSS(stringCSS);
          } else {
            values[property] = this.getCSSPropertyValue(stringCSS);
          }
        }
      }

      return values;
    }

    getFinalSettings(settings = {}) {
      const duration = this.duration;
      const timing = this.timing;
      const draw = this.draw.bind(this);
      const finalSettings = Object.assign({
          duration,
          timing,
          draw
        },
        settings
      );
      finalSettings.timingFunction = this.timingFunctions[finalSettings.timing].bind(this);

      return finalSettings;
    }

    getStepValues(start, time, duration, timingFunction) {
      const timeFraction = Math.min(1, (time - start) / duration);
      const progress = timingFunction(timeFraction);

      return {
        timeFraction,
        progress
      };
    }

    getCSSProperty(element, property) {
      return window.getComputedStyle(element).getPropertyValue(property);
    }

    getCSSPropertyValue(stringCSS) {
      return helpers.processSingleOrObject(stringCSS, string => {
        return Number(string.replace(/([a-zA-z%()])+/g, ''));
      });
    }

    getProgressValue(initialValue, finishValue, progress) {
      return initialValue + ((finishValue - initialValue) * progress);
    }

    getTransformObjectFromCSS(stringCSS) {
      const matrix = stringCSS === 'none' ? {
        a: 1,
        b: 0,
        c: 0,
        d: 1,
        e: 0,
        f: 0
      } : new DOMMatrixReadOnly(stringCSS);

      return {
        scaleX: matrix.a,
        skewY: matrix.b,
        skewX: matrix.c,
        scaleY: matrix.d,
        translateX: matrix.e,
        translateY: matrix.f
      }
    }

    buildMatrixCSS(data, dataCSS) {
      let transformCSS = [];
      const addTransformProperty = (name, defaultValue) => {
        if (data[name] !== undefined && data[name] !== defaultValue) transformCSS.push(`${name}(${dataCSS[name]})`);
      };

      addTransformProperty('scaleX', 1);
      addTransformProperty('skewY', 0);
      addTransformProperty('skewX', 0);
      addTransformProperty('scaleY', 1);
      addTransformProperty('translateX', 0);
      addTransformProperty('translateY', 0);
      return transformCSS.join(' ');
    }

    buildCSSTemplate(stringCSS, numberValue) {
      return stringCSS.replace(numberValue, '{n}');
    }

    buildCSSPropertyByTemplate(template, value) {
      return template.replace('{n}', value);
    }

    rebuildNewCSSPropertyValue(stringCSS, value, currentValue) {
      currentValue = currentValue || this.getCSSPropertyValue(stringCSS);
      const templateCSS = this.buildCSSTemplate(stringCSS, currentValue);
      const newValueCSS = this.buildCSSPropertyByTemplate(templateCSS, value);
      return newValueCSS;
    }

    setCSSCssText(element, strings) {
      element.style.cssText += strings.join('; ');
    }

    setCSSProperty(element, property, valueCSS) {
      element.style[property] = valueCSS;
    }

    setJSProperty(element, property, value) {
      if (element === window) {
        if (property === 'scrollY') {
          element.scrollTo(0, value);
        }
      } else if (property === 'scrollY') {
        element.scrollTop = value;
      } else if (property === 'scrollX') {
        setLogicalScrollLeft(element, value);
      }
    }

    setWillChange(element, properties, settings) {
      if (element === window) return;

      let value = [];

      for (const property in properties) {
        if (property === 'scrollY' || property === 'scrollX') continue;

        value.push(property);
      }

      value = value.join(', ');

      const setCSSProperty = (elem = element) => {
        this.setCSSProperty(elem, 'will-change', value);
      };

      setCSSProperty();

      if (settings.duplicate) {
        settings.duplicate.forEach(element => setCSSProperty(element));
      }
    }

    unsetWillChange(element, settings) {
      if (element === window) return;

      const unsetCSSProperty = (elem = element) => {
        this.setCSSProperty(elem, 'will-change', '');
      };

      unsetCSSProperty();

      if (settings.duplicate) {
        settings.duplicate.forEach(element => unsetCSSProperty(element));
      }
    }

    callSettingsCallbacks(stepData, callbacks) {
      const settings = stepData.element.animationObject.settings;

      stepData.statuses.forEach(status => {
        if (status === 'complete' && settings.disableCompleteCallbacks) {
          return;
        }
        if (callbacks[status]) callbacks[status](stepData);
        if (settings[status]) settings[status](stepData);
      });
    }

    hasEventInfo(element, str) {
      return element.animationObject && element.animationObject.settings.event.eventInfo.includes(str);
    }
  }

  window.animation = new Animation();

  themeBase.onDOMContentLoadedTrigger(() => {
    scriptController.scripts.push('animation.js');
  });
}